import { EliteWrappedResponse } from '../types/eliteWrapped.types'

export const eliteWrappedMockData: EliteWrappedResponse = {
  eliteRenewalStatus: 'EXPIRED_ELITE',
  frameData: [
    {
      line1: 'Recap'
    },
    {
      line1: "It's been a year since you became an Elite member.",
      line2: "Let's look at how your portfolio has evolved this past year.",
      line3: 'Through it all, our goal remains unchanged: help you invest better.'
    },
    {
      line1: 'A year ago, your portfolio was at ₹12.4L',
      line2: 'Up by 10% from last year.',
      line3: "That's a sign of a strong portfolio — invested in the right funds.",
      line4: 'You are already an ace investor :)',
      line5: 'Keep the momentum going.'
    },
    {
      line1: 'You stayed invested through market ups and downs',
      line2: 'in the past year',
      line3: "That's a sign of a disciplined investor."
    },
    {
      line1: 'You invested in 9 out of 12 months',
      line2: 'Consistency builds long-term wealth.',
      line3: 'Great, you are serious about your investments.',
      line4: 'A few more months and you hit a perfect streak.'
    },
    {
      line1: 'Your top holding grew the most',
      line2: 'Backed by strong fund managers and clear strategy.',
      line3: 'Diversification kept risk in check.',
      line4: 'Elite insights helped you stay on course.'
    },
    {
      line1: '₹2.1L invested via SIPs this year',
      line2: 'SIPs turned volatility into opportunity.',
      line3: 'Automated discipline = compounding at work.',
      line4: 'Smart rebalance suggestions kept you aligned.'
    },
    {
      line1: '65% of your portfolio',
      line2: 'is invested in the Top 3 funds',
      line3: 'Up by 5% since last year.',
      line4: 'Quality picks + timely reviews = Elite edge.'
    },
    {
      line1: 'You reviewed your portfolio 4 times',
      line2: 'Each review surfaced actionable insights.',
      line3: 'Small tweaks added up over the year.'
    },
    {
      line1: 'One year down, many more to go.',
      line2: "Here's to another year with Elite :)",
      line3: "We're excited to continue being part of your investing journey.",
      line4: 'Renew your Elite membership to keep every benefit active.',
      line5: 'Your younger self would be proud of this discipline.',
      line6: 'Ready for year two?'
    },
    {
      line1: '30K+ Elite members trust PowerUp',
      line2: 'You are in great company.',
      line3: 'Stay Elite. Stay ahead.',
      line4: 'Tap through to see what is next for you.'
    },
    {
      line1: 'Thanks for an incredible year',
      line2: 'Your 2025 Elite recap is complete.',
      line3: 'See you in the next chapter.',
      line4: 'Finish strong — we are with you.'
    }
  ]
}
